import { render } from "./PosReceiptRefund.vue?vue&type=template&id=5f5c7829&scoped=true&ts=true"
import script from "./PosReceiptRefund.vue?vue&type=script&lang=ts"
export * from "./PosReceiptRefund.vue?vue&type=script&lang=ts"

import "./PosReceiptRefund.vue?vue&type=style&index=0&id=5f5c7829&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5c7829"]])

export default __exports__